import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import StyledIcon from './Icon.style.js';

const Icon = ({
  icon,
  alignment
}) => /*#__PURE__*/React$1.createElement(StyledIcon, {
  icon: icon
}, alignment === 'right' ? /*#__PURE__*/React$1.createElement(React$1.Fragment, null, "\xA0") : '', /*#__PURE__*/React$1.createElement("span", {
  className: "icon__icon"
}), alignment === 'left' ? /*#__PURE__*/React$1.createElement(React$1.Fragment, null, "\xA0") : '');

Icon.propTypes = {
  icon: PropTypes$1.string,
  alignment: PropTypes$1.oneOf(['right', 'left'])
};
Icon.defaultProps = {
  icon: 'default',
  alignment: 'right'
};

export default Icon;
